import { CommunityType } from 'state';
import { convertDDToDMS } from 'utils';

export const exportCommunityCSV = (community: CommunityType) => {
  const csvArray = ['Address,Community(optional),Property ID(optional),GPS(optional)'];

  community.properties.forEach((property, i) => {
    const propertyColumns = [
      `"${property.address}"`,
      `"${community.name}"`,
      property.externalId,
      property.latitude !== null && property.longitude !== null
        ? `${convertDDToDMS(property.latitude, true)} ${convertDDToDMS(
            property.longitude,
            false,
          )}`
        : '',
    ];

    csvArray.push(propertyColumns.join(','));
  });

  const blob = new Blob([csvArray.join('\n')], { type: 'text/csv' });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = `${community.name}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
